import Icon from '../components/Icon.vue'

Icon.register({
  'dice-d20': {
    width: 480,
    height: 512,
    paths: [
      {
        d: 'M106.8 215.1l108.6 190.1-208.3-22.1c-5.8-0.6-9-7.1-5.9-12.1zM7.4 315.4c-2.1 3.4-7.4 1.9-7.4-2.1v-162.8c0-3.1 3.4-5 6.1-3.4l76.6 46zM18.3 423.6c-4-2-2.3-8.1 2.2-7.6l203.6 22.3v65.7c0 5.8-6 9.7-11.3 7.3zM99.5 165.8l-81.5-48.7c-2.5-1.5-2.6-5.2-0.1-6.8l150.8-98.6c7.2-4.1 15.1 4.1 10.8 11.1zM240 176h-109.2l95.6-168.4c3.1-5.1 8.4-7.6 13.6-7.6s10.5 2.5 13.6 7.6l95.6 168.4h-109.2zM473.9 147.1c2.7-1.6 6.1 0.3 6.1 3.4v162.8c0 4-5.3 5.5-7.4 2.1l-75.3-122.4zM380.5 165.8l-79.9-142.9c-4.3-7.1 3.6-15.3 10.8-11.1l150.8 98.6c2.5 1.6 2.4 5.3-0.1 6.8zM459.6 416c4.5-0.5 6.2 5.6 2.2 7.6l-194.4 87.7c-5.3 2.5-11.3-1.4-11.3-7.3v-65.7zM373.3 215.1l105.6 155.9c3.1 5-0.1 11.5-5.9 12.1l-208.3 22.1zM240 208h100.4l-100.4 175.8-100.4-175.8h100.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dice-d20.js
// module id = 1258
// module chunks = 0